<template lang="pug">
v-row.mb-10
  v-container.fill-height(fluid v-if="!loggedin")
    v-row(align="center", justify="center")
      v-col(cols="12", sm="8", md="6")
        v-card.elevation-12
          v-toolbar(color="primary", dark, flat)
            v-toolbar-title Dealer Login
          v-card-text
            v-form
              v-text-field(
                label="Login",
                name="login",
                prepend-icon="mdi-account",
                type="text",
                v-model="username",
                autocomplete="username"
              )
              v-text-field#password(
                label="Password",
                name="password",
                prepend-icon="mdi-lock",
                type="password",
                v-model="password",
                autocomplete="current-password"
              )
            v-card-actions
              v-btn(@click="forgotpassword", text) Forgot Password
              v-spacer
              v-btn(text @click="newSignup") New Dealer Signup
              v-btn(color="primary", @click="login") Login



  div(v-if="loggedin" class="col-12")
    v-tabs-items(v-model="tab" class="full-height-tab" grow style="width:100%;")
      v-tab-item
        v-card(elevation=0)
          v-card-title
            v-icon mdi-domain
            span.px-4 Dealer Information
          v-card-text
            v-expansion-panels
              v-expansion-panel
                v-expansion-panel-header
                  div.text-h6
                    v-icon mdi-domain
                    span.px-4 Contact Details
                v-expansion-panel-content
                  v-row
                    v-col(cols=12)
                      v-text-field(v-model="settings.name", label="Dealer Name")
                    v-col(cols=12, lg=6)
                      v-text-field(
                        v-model="settings.contactEmail",
                        label="Contact Email",
                        :rules="[rules.required, rules.email]"
                      )
                    v-col(cols=12, lg=6)
                      v-text-field(
                        v-model="settings.contactPhone",
                        label="Contact Phone"
                      )
                    v-col(cols=12, lg=6)
                      AddressFinder(
                        :model="settings.addressData",
                        :clear="true",
                        label="Dealer Location"
                      )
                    v-col(cols=12, lg=6)
                      v-text-field(
                        v-model="settings.listingLink",
                        label="Link to listings"
                      )
                    v-col(cols=12, lg=6)
                      v-text-field(
                        v-model="settings.baseURL",
                        label="Base URL for listings"
                      )
                    v-col(cols=12)
                      h4 About your business
                      tiptap-vuetify(
                        v-model="settings.referralMessage",
                        label="Referral message",
                        :extensions="extensions",
                        style="min-height:0;"
                        :toolbar-attributes="{ color: 'black', dark: true }"
                      )
              v-expansion-panel
                v-expansion-panel-header
                  div.text-h6
                    v-icon mdi-palette-outline
                    span.px-4 Theme
                v-expansion-panel-content
                  div.text-h6 Landing Page Mode
                  v-select(
                    solo,
                    :items="modes",
                    item-text="label",
                    item-value="type",
                    v-model="settings.serviceType",
                    label="Select Landing Page Mode",
                    persistent-hint,
                    attach
                  )
                  v-switch(v-model="settings.theme.dark", label="Dark Theme")
                  v-row
                    v-col(cols=12, lg=6)
                      div.text-h6 Primary Colour
                      v-color-picker(v-model="settings.theme.primary")
                    v-col(cols=12, lg=6)
                      div.text-h6 Secondary Colour
                      v-color-picker(v-model="settings.theme.secondary")
                    v-col(cols=12, lg=6)
                      div.text-h6 Title Colour
                      v-color-picker(v-model="settings.theme.accent")
                    v-col(cols=12, lg=6)
                      div.text-h6 Link Colour
                      v-color-picker(v-model="settings.theme.anchor")
            v-card-actions
              v-spacer
              v-btn.secondary.mx-2(@click="goHome") Home
              v-btn.primary.mx-2(@click="saveSettings") Save
      v-tab-item
        v-card(elevation=0)
          v-card-title
            v-icon mdi-cogs
            span.px-4 Settings
          v-card-text
            v-expansion-panels
              v-expansion-panel
                v-expansion-panel-header
                  div.text-h6 
                    v-icon mdi-cogs
                    span.px-4 Algorithm Settings
                v-expansion-panel-content

                  v-row
                    v-col(cols=12, lg=6)
                      v-text-field(
                        v-model.number="settings.default_settings.homekWh",
                        type="number",
                        label="Home charging cost per kWh"
                      )
                    v-col(cols=12, lg=6)
                      v-text-field(
                        v-model.number="settings.default_settings.homePerMinute",
                        type="number",
                        label="Home charging per minute"
                      )
                  v-row
                    v-col(cols=12, lg=6)
                      v-text-field(
                        v-model.number="settings.default_settings.publickWh",
                        type="number",
                        label="Public charging cost per kWh"
                      )
                    v-col(cols=12, lg=6)
                      v-text-field(
                        v-model.number="settings.default_settings.publicPerMinute",
                        type="number",
                        label="Public charging per minute"
                      )
                  v-row
                    v-col(cols=12, lg=6)
                      v-text-field(
                        v-model.number="settings.default_settings.annualMaintenanceICE",
                        type="number",
                        label="Annual maintenance for ICE vehicle"
                      )
                    v-col(cols=12, lg=6)
                      v-text-field(
                        v-model.number="settings.default_settings.annualMaintenanceEV",
                        type="number",
                        label="Annual maintenance for EV"
                      )
                  v-row
                    v-col(cols=12, lg=6)
                      v-text-field(
                        v-model.number="settings.default_settings.petrolCost",
                        type="number",
                        label="Petrol cost per litre"
                      )
                    v-col(cols=12, lg=6)
                      v-text-field(
                        v-model.number="settings.default_settings.dieselCost",
                        type="number",
                        label="Diesel cost per litre"
                      )
                  v-row
                    v-col(cols=12, lg=6)
                      v-text-field(
                        v-model.number="settings.default_settings.RUCperThousand",
                        type="number",
                        label="Road User Charges per 1000km"
                      )
                    v-col(cols=12, lg=6)
                      v-text-field(
                        v-model.number="settings.default_settings.recommendationAdjustmentFactor",
                        type="number",
                        persistent-hint
                        label="Time cost of stopping to charge (dollars per charging stop)"
                        hint="Higher numbers recommend higher battery capacity vehicles"
                      )
                  v-row
                    v-col(cols=12, lg=6)
                      v-checkbox(
                        v-model="settings.default_settings.excludeORC",
                        label="Tick if car prices exclude ORC"
                      )
                  v-row
                    v-col(cols=12)
                      h4 Disclaimer
                      tiptap-vuetify(
                        v-model="settings.disclaimer",
                        label="Important details or disclaimer",
                        :extensions="extensions",
                        :toolbar-attributes="{ color: 'black', dark: true }"
                      )
              v-expansion-panel
                v-expansion-panel-header
                  div.text-h6
                    v-icon mdi-car-cog
                    span.px-4 Car Type Settings
                v-expansion-panel-content(
                  v-if="settings.default_settings.carTypes"
                )
                  div 
                    v-img(
                      src="https://powersell.appstack.me/icons/hybrid.svg",
                      width="50",
                      height="50",
                      style="transform: scaleX(-1)",
                      :class="{ white: $vuetify.theme.dark }"
                    )
                    span.px-4 Hybrid
                  v-row
                    v-col(cols=12, lg=6)
                      v-text-field(
                        v-model.number="settings.default_settings.carTypes[0].petrolConsumption",
                        type="number",
                        label="Petrol Consumption km/l"
                      )
                    v-col(cols=12, lg=6)
                      v-text-field(
                        v-model.number="settings.default_settings.carTypes[0].dieselConsumption",
                        type="number",
                        label="Diesel Consumption km/l"
                      )
                  div 
                    v-img(
                      src="https://powersell.appstack.me/icons/compact.svg",
                      width="50",
                      height="50",
                      :class="{ white: $vuetify.theme.dark }"
                    )
                    span.px-4 Efficient
                  v-row
                    v-col(cols=12, lg=6)
                      v-text-field(
                        v-model.number="settings.default_settings.carTypes[1].petrolConsumption",
                        type="number",
                        label="Petrol Consumption km/l"
                      )
                    v-col(cols=12, lg=6)
                      v-text-field(
                        v-model.number="settings.default_settings.carTypes[1].dieselConsumption",
                        type="number",
                        label="Diesel Consumption km/l"
                      )
                  div 
                    v-img(
                      src="https://powersell.appstack.me/icons/standard_car.svg",
                      width="50",
                      height="50",
                      v-bind:class="{ white: $vuetify.theme.dark }"
                    )
                    span.px-4 Standard
                  v-row
                    v-col(cols=12, lg=6)
                      v-text-field(
                        v-model.number="settings.default_settings.carTypes[2].petrolConsumption",
                        type="number",
                        label="Petrol Consumption km/l"
                      )
                    v-col(cols=12, lg=6)
                      v-text-field(
                        v-model.number="settings.default_settings.carTypes[2].dieselConsumption",
                        type="number",
                        label="Diesel Consumption km/l"
                      )
                  div 
                    v-img(
                      src="https://powersell.appstack.me/icons/gas_guzzler.svg",
                      width="50",
                      height="50",
                      :class="{ white: $vuetify.theme.dark }"
                    )
                    span.px-4 Gas Guzzler
                  v-row
                    v-col(cols=12, lg=6)
                      v-text-field(
                        v-model.number="settings.default_settings.carTypes[3].petrolConsumption",
                        type="number",
                        label="Petrol Consumption km/l"
                      )
                    v-col(cols=12, lg=6)
                      v-text-field(
                        v-model.number="settings.default_settings.carTypes[3].dieselConsumption",
                        type="number",
                        label="Diesel Consumption km/l"
                      )
            v-card-actions
              v-spacer
              v-btn.secondary.mx-2(@click="goHome") Home
              v-btn.primary.mx-2(@click="saveSettings") Save
      v-tab-item
        v-card(elevation=0)
              v-card-title
                v-icon mdi-car-multiple
                span.px-4 Car Stock

              v-card-text
                v-row
                  v-col(cols=12, lg=4, v-for="car of carData", :key="car.id")
                    CarEditor(:car="car", :models="modelData")
              v-card-actions
                v-spacer
                v-btn.primary(@click="addCar") Add Car
                v-btn.primary.mx-2(@click="saveSettings") Save

      v-tab-item
        v-card(elevation=0)
          v-card-title
            v-icon mdi-account-convert
            span.px-4 Referrals
          v-card-text
            v-expansion-panels
              v-expansion-panel
                v-expansion-panel-header
                  div.text-h6
                    v-icon mdi-account-convert
                    span.px-4 Updated Referrals
                v-expansion-panel-content
                  v-row
                    v-col(cols=12)
                      ReferralCard(
                        v-for="r of updatedReferrals",
                        :key="r.referralCode",
                        :referral="r"
                      )
              v-expansion-panel
                v-expansion-panel-header
                  div.text-h6
                    v-icon mdi-cash-check
                    span.px-4 Completed Sales
                v-expansion-panel-content
                  v-row
                    v-col(cols=12)
                      ReferralCard(
                        v-for="r of completedReferrals",
                        :key="r.referralCode",
                        :referral="r"
                      )
              v-expansion-panel
                v-expansion-panel-header
                  div.text-h6
                    v-icon mdi-account-convert-outline
                    span.px-4 Pending Referrals
                v-expansion-panel-content
                  v-row
                    v-col(cols=12)
                      ReferralCard(
                        v-for="r of pendingReferrals",
                        :key="r.referralCode",
                        :referral="r"
                      )
      v-tab-item
        v-card(elevation=0)
          v-card-title
                v-icon mdi-message
                span.px-4 Send a notification
          v-card-text
              v-text-field(
                v-model="updateTitle",
                label="Notification Title",
                outlined
              )
              v-textarea(
                v-model="updateMessage",
                hint="Enter a message to send to your customers",
                label="Notification Message",
                outlined
              )
              div.text-h6 Add recipients
              v-select(
                v-model="recipientFilter",
                :items="notificationSettings",
                label="Select Notification Type",
                single-line,
                @change="updateNotifications"
              )
              v-text-field(
                 prepend-inner-icon="mdi-flash"
                v-model.number="awardedPoints",
                    type="number",
                    label="Award Lightning Points (for each recipient)")
              v-checkbox(
                v-for="c of crewMembers",
                :key="c.id",
                :label="`${c.name} ${c.email}`",
                v-model="selectedCrewMembers",
                :value="c.id"
              )
              v-card-actions
                v-spacer
                v-dialog(v-model="dialog", max-width="640")
                  template(v-slot:activator="{ on }")
                    v-btn(v-on="on", color="primary") Send Update
                  v-card(
                    v-if="updateTitle && updateMessage && selectedCrewMembers.length > 0"
                  )
                    v-card-title Confirm Send Update
                    v-card-text
                      div.text-h6 {{ updateTitle }}
                      p {{ updateMessage }}
                      p Recipients: {{ selectedCrewMembers.length }}
                      p Lightning Points Cost: {{ selectedCrewMembers.length * awardedPoints }}
                    v-card-actions
                      v-btn.primary(@click="sendMessage", fullwidth) Send
                  v-card(
                    v-if="!updateTitle || !updateMessage || selectedCrewMembers.length == 0 || awardedPoints < 1"
                  )
                    v-card-title Missing fields
                    v-card-text
                      p.warning.pa-2.ma-2(v-if="!updateTitle") Please enter a title
                      p.warning.pa-2.ma-2(v-if="!updateMessage") Please enter a message
                      p.warning.pa-2.ma-2(
                        v-if="selectedCrewMembers.length == 0"
                      ) Please select some crew members
                      p.warning.pa-2.ma-2(v-if="awardedPoints < 1") You must award at least 1 point to recipients
                    v-card-actions
                      v-btn(@click="dialog = false") Back
      v-tab-item
        v-card(elevation=0)
          v-card-title
              v-icon mdi-account-question-outline
              span.px-4 Enquiries
          v-card-text
              EnquiryCard(
                v-for="enq of enquiries",
                :key="enq.ID",
                :enquiry="enq"
              )
              div.text-h6(v-if="enquiries.length == 0") No Enquiries
      v-tab-item
        v-card(elevation=0)
          v-card-title
              v-icon mdi-account-group-outline
              span.px-4 My Customers
          v-card-text
              CrewCard(v-for="c of crewMembers", :key="c.id", :crew="c")
              div.text-h6(v-if="crewMembers.length == 0") No customers yet
          v-card-actions
            v-spacer
            v-btn.primary(@click="signup") Add Customer
        v-card(elevation=0)
          NewAccount(v-if="signupMode == 1" dealerMode="true")
      v-tab-item(grow)
        v-card(elevation=0)
          v-card-title
              v-icon mdi-code-tags
              span.px-4 Website Embedding
          v-card-text
              p Copy and paste this code into your website to embed PowerSell

              pre.code {{ embedCode }}
          v-card-actions
              v-spacer
              v-btn.my-4.primary(@click="copyCode")
                v-icon mdi-content-copy
                span Copy
      v-tab-item
        v-card(elevation=0)
          v-card-title
              v-icon mdi-credit-card-settings-outline
              span.px-4 Payment Details
          v-card-text
              div(v-if="settings.cardLastDigits && niceExpiry")
                div.text-h6 Card on file
                v-text-field.pre(
                  :value="'**** **** **** ' + settings.cardLastDigits",
                  label="Card Number",
                  filled,
                  readonly
                )
                v-text-field.pre(
                  :value="niceExpiry",
                  label="Expiry",
                  filled,
                  readonly
                )
              v-dialog(
                v-model="paymentDialog",
                max-width="640",
                :persistent="!clickToClose"
              )
                template(v-slot:activator="{ on }")
                  v-btn(v-on="on", color="primary", small, block) Update Payment Details
                v-card
                  v-card-title Payment Details
                  v-card-text
                    p Please provide a card on file to cover your monthly subscription and additional charges.
                    v-stripe-card(
                      v-model="source",
                      ref="stripeCard",
                      @focus="onFocus",
                      @input="onProcessed",
                      api-key="pk_test_piJkpNBbxRaqA3M6oWjmWAQb0057E6vl6y",
                      :hidePostalCode="true",
                      create="source"
                    )
                    p 
                      | I agree to the
                      a(
                        href="https://powertrip.earth/power-trip-dealer-customer-terms-and-conditions.pdf"
                      ) Power Trip terms and conditions
                      |
                      | and authorise PowerTrip to send instructions to the financial institution that issued my card to take payments from my card account in accordance with the terms of my agreement with you.
                    p 
                      | For more information contact
                      a(href="mailto:info@powertrip.earth") info@powertrip.earth
                      |
                      | or call 022 6495517
      v-tab-item
        v-card(elevation=0)
          v-card-title Voucher Management
          v-card-text
            v-dialog(
              v-model="voucherDialog",
              max-width="640",
              :persistent="!clickToClose"
             )
              template(v-slot:activator="{ on }")
                v-btn(v-on="on", color="primary", small, block @click="voucher = null") Create New Voucher
              v-card(v-if="!voucher")
                v-card-title Voucher Details
                v-card-text
                  p Create a voucher here, you will be given the option to download or email the created voucher once it is generated.
                  v-text-field(type="number" label="Number of points" v-model="voucherPoints" min=100 :rules="minRules")
                v-card-actions
                  v-spacer
                  v-btn.primary(@click="generateVoucher") Generate Voucher
              v-card(v-if="voucher")
                v-card-title Voucher Generated
                v-card-text
                  h3 {{ voucher.code }}
                  v-text-field(type="email" label="Send via email" v-model="voucherEmail")
                v-card-actions
                  v-btn.primary(@click="emailVoucher") Send Voucher via Email
                  v-spacer
                  v-btn.primary(@click="downloadPDF") Download PDF
                vue-html2pdf.fixpos(:show-layout="false"
                    :enable-download="true"
                    :preview-modal="true"
                    filename="PowerTripVoucher"
                    :pdf-quality="2"
                    :manual-pagination="true"
                    pdf-orientation="portrait"
                    pdf-content-width="210mm"
                    pdf-format="a4"
                    :html-to-pdf-options="pdfoptions"
                    ref="html2Pdf")
                    section(slot="pdf-content")
                      section(class="pdf-item")
                        div.voucher
                          div.firstbox
                            h1 {{ voucher.amount }} points from {{ $dealer.default_settings.name }}
                          div.secondbox
                            h1 {{ voucher.code}}
            v-data-table(
              :headers="voucherHeaders",
              :items="voucherList",
              :items-per-page="50"
            )
              template(v-slot:item.action="{ item }")
                v-btn(icon @click="sendVoucher(item)")
                  v-icon mdi-send
              template(v-slot:item.redeemed="{ item }")
                v-simple-checkbox(v-model="item.redeemed" disabled)

          v-card-actions
            v-spacer
  
  v-snackbar(v-model="snackbar", :timeout="4000") {{ messageText }}
    v-progress-circular(color="pink", indeterminate)
</template>

<script>
import AddressFinder from "../components/AddressFinder";
import CarEditor from "../components/CarEditor";
import ReferralCard from "../components/ReferralCard";
import Dealer from "../services/Dealer";
import EnquiryCard from "../components/EnquiryCard";
import CrewCard from "../components/CrewCard";
import Vue from "vue";
import { menuBus } from "../main";
import NewAccount from "../views/NewAccount";
import VueHtml2pdf from "vue-html2pdf";
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from "tiptap-vuetify";

export default {
  data() {
    return {
      recipientFilter: "",
      source: null,
      paymentDialog: false,
      clickToClose: true,
      stripeCardInitialized: false,
      snackbar: false,
      messageText: "",
      crewMembers: [],
      selectedCrewMembers: [],
      updateMessage: "",
      updateTitle: "",
      allSelected: false,
      dialog: false,
      voucherPoints: 0,
      voucherDialog: false,
      voucherEmail: null,
      voucher: null,
      voucherList: [],
      limit: 100,
      minRules: [
        (v) => {
          if (v < this.limit) {
            return "You need a minimum of 100 points per voucher";
          }
        },
      ],
      pdfoptions: {
        width: "297mm",
        height: "210mm",
        margin: 0,
        html2canvas: {
          dpi: 192,
          scale: 4,
          letterRendering: true,
        },
      },
      voucherHeaders: [
        {
          text: "Created",
          value: "created",
        },
        {
          text: "Code",
          value: "code",
        },
        {
          text: "Redeemed",
          value: "redeemed",
        },
        {
          text: "Updated",
          value: "updated",
        },
        {
          text: "Email / PDF",
          value: "action",
        },
        {
          text: "Sent To",
          value: "sent",
        },
        {
          text: "Claimed by",
          value: "claimed",
        },
      ],
      loggedin: false,
      recipients: [],
      enquiries: [],
      awardedPoints: 1,
      signupMode: 0,
      modes: [
        { type: "0", label: "Default" },
        { type: "1", label: "Commute" },
        { type: "2", label: "Home Base" },
        { type: "3", label: "Route Planner" },
      ],
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      address: {},
      //loggedin: false,
      mode: "menu",
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      username: "",
      password: "",
      settings: this.$dealer.default_settings,
      tab: 0,
      referrals: [],
    };
  },
  created() {
    menuBus.$on("menuItem", (item) => {
      this.tab = item;
    });
    this.updateVoucherList();
  },
  methods: {
    newSignup() {
      this.$router.push("/signup");
    },
    sendVoucher: function (v) {
      this.voucher = v;
      this.voucherDialog = true;
    },
    updateVoucherList: async function () {
      let v = await Dealer.getVouchers();
      v.forEach((v) => (v.redeemed = v.redeemed == 1 ? true : false));
      this.voucherList = v;
    },
    downloadPDF: function () {
      window.scrollTo(0, 0);
      this.$refs.html2Pdf.generatePdf();
    },
    emailVoucher: async function () {
      if (this.voucherEmail && this.voucher && this.voucher.code) {
        this.showMessage("Sending voucher...");
        try {
          await Dealer.emailVoucher(this.voucherEmail, this.voucher.code);
          this.showMessage("Email sent", false);
          this.updateVoucherList();
        } catch (e) {
          console.log(e);
          this.showMessage("Email failed", false);
        }
        this.voucher = null;
        this.voucherDialog = false;
      }
    },
    generateVoucher: async function () {
      if (this.voucherPoints >= this.limit) {
        this.showMessage("Generating voucher...");

        var r = await Dealer.generateVouchers(this.voucherPoints);
        this.voucher = r;
        this.snackbar = false;
        this.updateVoucherList();
      }
    },
    signup: function () {
      this.signupMode = 1;
    },
    forgotpassword: function () {
      window.open("https://thepowertrip.co.nz/Security/lostpassword");
    },
    logout: function () {
      localStorage.removeItem("credentials");
      window.location.reload();
    },
    onFocus: function () {
      if (!this.stripeCardInitialized) {
        this.stripeCardInitialized = true;
        this.$watch(
          () => this.$refs.stripeCard.okToSubmit,
          (value) => {
            console.log(value);
            this.$refs.stripeCard.processCard();
          }
        );
      }
    },
    onProcessed: function () {
      this.settings.cardLastDigits = this.source.card.last4;
      this.settings.cardExpiry =
        this.source.card.exp_year + "-" + this.source.card.exp_month + "-01";
      this.settings.stripeSecret = this.source.id;
      this.settings.stripePaymentMethod = this.source.type;
      console.log(this.source);
      this.showMessage("Saving settings...");
      this.paymentDialog = false;
      this.clickToClose = true;
      this.$dealer.save();
    },
    copyCode() {
      var $this = this;
      this.$copyText(this.embedCode).then(function (e) {
        $this.showMessage("Copied");
        console.log(e);
      });
    },
    showMessage(message) {
      this.messageText = message;
      this.snackbar = true;
    },
    selectAll() {
      this.crewMembers.forEach((element) => (element.selected = this.allSelected));
      this.selectedCrewMembers = this.crewMembers
        .filter((crew) => crew.selected)
        .map((crew) => crew.id);
    },
    async saveSettings() {
      this.showMessage("Saving settings and cars..");
      this.$dealer.save();
      await this.$dealer.saveCars(this.carData);
      this.carData = await this.$dealer.loadCars();
    },
    goHome() {
      this.$router.push("/");
    },
    sendMessage() {
      Dealer.sendUpdate(
        this.updateTitle,
        this.updateMessage,
        this.selectedCrewMembers,
        this.awardedPoints
      ).then((response) => {
        console.log(response);
      });
      this.dialog = false;
    },
    async login() {
      let loggedin = await this.$dealer.checklogin(this.username, this.password);
      console.log("LOGGED IN", loggedin);
      if (loggedin == "signup") {
        this.$router.push("/signup");
      }

      if (loggedin) {
        localStorage.setItem("credentials", this.username + "|@|!|" + this.password);
        this.loggedin = true;
        menuBus.$emit("show", true);
        this.carData = [];

        await Dealer.init(typeof loggedin == "boolean" ? null : loggedin, this.$vuetify);
        this.carData = this.$dealer.carData;
        this.referrals = await this.$dealer.getReferrals();

        var response = await Dealer.enquiries();
        this.enquiries = response;
        this.enquiries.sort((a, b) => b.ID - a.ID);

        Dealer.myCrew().then((resp) => {
          this.crewMembers = resp.crew;
          for (let i = 0; i < this.crewMembers.length; i++) {
            this.crewMembers.selected = false;
          }
        });

        if (!this.settings.cardLastDigits || !this.settings.cardExpiry) {
          this.tab = 8;
          this.paymentDialog = true;
          this.clickToClose = false;
        }
      } else {
        localStorage.removeItem("credentials");
        this.username = "";
        this.password = "";
        menuBus.$emit("show", false);
      }
    },
    addCar() {
      this.carData.push({
        Image: "",
        ModelID: 1,
        Price: 0,
        Year: 2020,
        Soh: 100,
        Name: "",
        ListingLink: "",
      });
    },
    updateNotifications(type) {
      switch (type) {
        case "Select Everyone":
          this.allSelected = true;
          this.selectAll();
          break;
        case "Select No One":
          this.allSelected = false;
          this.selectAll();
          break;
        default:
          this.selectedCrewMembers = this.crewMembers
            .filter((crew) => crew.alertChoices.some((e) => e.name === type))
            .map((crew) => crew.id);
      }
    },
  },
  mounted() {
    if (localStorage.getItem("credentials")) {
      let split = localStorage.getItem("credentials").split("|@|!|");
      if (split.length == 2) {
        this.username = split[0];
        this.password = split[1];
        this.login();
      }
    }
    Vue.prototype.$Countly.q.push([
      "add_event",
      {
        key: "Dealer Page",
        segmentation: {
          dealer: this.$dealer.default_settings.name,
        },
      },
    ]);
  },
  watch: {
    "settings.theme": {
      handler: function () {
        this.$dealer.updateTheme(this.$vuetify);
      },
      deep: true,
    },
  },
  computed: {
    notificationSettings() {
      let options = ["Select Everyone", "Select No One"];
      this.crewMembers.forEach((element) => {
        options = options.concat(element.alertChoices.map((e) => e.name));
      });
      return [...new Set(options)];
    },
    niceExpiry() {
      if (this.settings.cardExpiry) {
        let components = this.settings.cardExpiry.split("-");
        if (components.length == 3) {
          return components[1] + "/" + components[0];
        }
      }
      return false;
    },
    embedCode() {
      return (
        "<power-sell servicecode=" +
        this.$dealer.serviceCode +
        '> <img id="loading" src="https://powersell.appstack.me/ezgif.com-gif-maker.gif" alt="Loading..." style="position: absolute;top:50%;left:50%;transform:translate"/>' +
        "</power-sell> \n" +
        "<script src='//powersell.appstack.me/js/app.js' async><" +
        "/script>"
      );
    },
    pendingReferrals() {
      return this.referrals.filter((r) => !r.referredEmail && !r.referredName);
    },
    updatedReferrals() {
      return this.referrals.filter(
        (r) =>
          (r.referredEmail || r.referredName) &&
          (!r.referrerRewarded || !r.referredRewarded)
      );
    },
    completedReferrals() {
      return this.referrals.filter((r) => r.referrerRewarded || r.referredRewarded);
    },
    carList() {
      var cars = [];
      for (let i = 0; i < this.carData.length; i++) {
        let car = this.carData[i];
        let newCar = !car.ID;

        let model = this.modelData.find((o) => o.ID === car.ModelID);
        if (model !== undefined) {
          let mergedCar = { ...model, ...car };
          mergedCar.ConsumptionRatio =
            mergedCar.MaxRange /
            mergedCar.BatterySize /
            (this.referenceEPARange / this.referenceBatterySize);
          if (mergedCar.Name === undefined || mergedCar.Name === null) {
            mergedCar.Name = "";
          }
          if (newCar) {
            mergedCar.ID = 0;
          }
          cars.push(mergedCar);
        } else {
          cars.push(car);
        }
      }

      return cars;
    },
  },
  components: {
    AddressFinder,
    CarEditor,
    TiptapVuetify,
    ReferralCard,
    EnquiryCard,
    CrewCard,
    NewAccount,
    VueHtml2pdf,
  },
};
</script>

<style scoped lang="scss">
header {
  min-height: 64px;
}

.white {
  filter: invert(1);
  mix-blend-mode: lighten;
}

.code {
  color: white;
  background: grey;
}

.pre {
  font-family: monospace;
}

.fixpos {
  position: fixed;
  top: 0;
  left: 0;
}

.voucher {
  width: 212mm;
  height: 297mm;
  background-image: url("https://powersell.appstack.me/voucher_portrait_2.png");
  background-size: cover;
  background-repeat: none;
  margin: 0;
  margin-left: -10px;
  margin-bottom: -1px;
  overflow-y: hidden;
  padding: 0;

  h1 {
    font-family: "Roboto Mono", monospace;
    font-size: 28px;
  }
  .firstbox {
    position: absolute;
    top: 212px;
    left: 60px;
    width: 700px;
    h1 {
      transform: translate(0%, -50%);
    }
  }
  .secondbox {
    position: absolute;
    top: 390px;
    left: 60px;
    width: 700px;
  }
}
@import url("https://fonts.googleapis.com/css2?family=Roboto+Mono&display=swap");
</style>
